const DB_NAME = "surf-library";
const DB_VERSION = 1;
const STORE = "library";
export class MemorySurfStore {
    snapshot = { decks: [], lastSyncedAt: "" };
    read() {
        return Promise.resolve(structuredClone(this.snapshot));
    }
    write(snapshot) {
        this.snapshot = structuredClone(snapshot);
        return Promise.resolve();
    }
}
export class IndexedDbSurfStore {
    db = null;
    async open() {
        if (this.db)
            return this.db;
        const db = await new Promise((resolve, reject) => {
            const req = indexedDB.open(DB_NAME, DB_VERSION);
            req.onupgradeneeded = () => {
                const opened = req.result;
                if (!opened.objectStoreNames.contains(STORE)) {
                    opened.createObjectStore(STORE);
                }
            };
            req.onsuccess = () => resolve(req.result);
            req.onerror = () => reject(req.error ?? new Error("IndexedDB open failed"));
        });
        this.db = db;
        return db;
    }
    async read() {
        const db = await this.open();
        return new Promise((resolve, reject) => {
            const tx = db.transaction(STORE, "readonly");
            const req = tx.objectStore(STORE).get("snapshot");
            req.onsuccess = () => {
                const value = req.result;
                resolve(value ?? { decks: [], lastSyncedAt: "" });
            };
            req.onerror = () => reject(req.error ?? new Error("IndexedDB read failed"));
        });
    }
    async write(snapshot) {
        const db = await this.open();
        return new Promise((resolve, reject) => {
            const tx = db.transaction(STORE, "readwrite");
            tx.objectStore(STORE).put(snapshot, "snapshot");
            tx.oncomplete = () => resolve();
            tx.onerror = () => reject(tx.error ?? new Error("IndexedDB write failed"));
        });
    }
}
export function reconcileDeckRecords(local, remote) {
    const map = new Map();
    for (const row of local)
        map.set(row.documentId, row);
    for (const row of remote) {
        const prev = map.get(row.documentId);
        if (!prev) {
            map.set(row.documentId, row);
            continue;
        }
        const localTs = prev.deck.contentUpdatedAt;
        const remoteTs = row.deck.contentUpdatedAt;
        map.set(row.documentId, remoteTs >= localTs ? row : prev);
    }
    return [...map.values()].filter((r) => !r.deleted);
}
export function snapshotFromRecords(records, lastSyncedAt) {
    return {
        decks: records.filter((r) => !r.deleted),
        lastSyncedAt,
    };
}
